'use client';

import React from 'react';
import Link from 'next/link';

// Fallback 404 for routes outside the [lang] segment.
// Most 404s are handled by app/[lang]/not-found.tsx which has full lang context.
export default function NotFound() {
    return (
        <div style={{ textAlign: 'center', padding: '4rem' }}>
            <h1>404 — Page not found</h1>
            <Link href="/">Go home</Link>
        </div>
    );
}
